// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiPipefySerializer } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";

interface NotarizationSupportParams {
  country: string;
  nid: string;
}

interface NotarizationSupportResponse {
  data?: unknown;
  message?: string;
  success: boolean;
}

export const notarizationSupport = apiPipefySerializer.injectEndpoints({
  endpoints: (builder) => ({
    triggerNotarizationSupport: builder.mutation<
      NotarizationSupportResponse,
      NotarizationSupportParams
    >({
      query: (body: NotarizationSupportParams) => ({
        body,
        method: "POST",
        url: "/notarization-support-trigger",
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "triggerNotarizationSupport",
        };
        return modelError;
      },
      transformResponse: (response: NotarizationSupportResponse) => {
        return response;
      },
    }),
  }),
});

export const { useTriggerNotarizationSupportMutation } = notarizationSupport;
